import React from "react";
import { usePermissions } from "../hooks/usePermissions";
import { AccessLevelEnum } from "@propertelligent/client-api";

interface PermissionGuardProps {
  permission: string;
  level?: AccessLevelEnum;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Component to protect UI elements based on user permissions
 * 
 * Usage:
 * <PermissionGuard permission="Property" level={AccessLevelEnum.All}>
 *   <button>Delete Property</button>
 * </PermissionGuard>
 */
export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permission,
  level = AccessLevelEnum.ReadOnly,
  children,
  fallback = null,
}) => {
  const { hasAccess } = usePermissions();

  if (hasAccess(permission, level)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};
